export default __webpack_public_path__ + "static/media/icon-more-grey.454c50a2.svg";